import { forwardRef, Children, isValidElement, cloneElement, ReactElement } from "react"
import StyledRadioButton from "./styles/RadioButtonStyles"
import { useRadioGroup } from "./Root"

type ItemOwnProps = Readonly<{
  name?: string
  value: string
}>

export type ItemProps = ItemOwnProps & React.ComponentPropsWithRef<typeof StyledRadioButton>
const Item: React.FC<ItemProps> = forwardRef(({ value, name, children, ...buttonProps }: ItemProps, forwardedRef) => {
  const { state, dispatch } = useRadioGroup(`Item`)

  const mappedChildren = Children.map(children, (child) => {
    if (isValidElement(child) && !Object.prototype.hasOwnProperty.call(child.props, `valueFor`)) {
      return cloneElement(child as ReactElement<{ checked: boolean }>, {
        checked: value === state.value,
      })
    }
    return child
  })

  const handleValueChange = () => {
    dispatch({
      type: `setValue`,
      value,
    })
  }

  return (
    <>
      <input
        id={value}
        name={name}
        title={name}
        type="radio"
        onChange={handleValueChange}
        disabled={state.disabled}
        hidden
      />
      <StyledRadioButton
        {...buttonProps}
        ref={forwardedRef}
        type="button"
        role="radio"
        disabled={state.disabled}
        checked={state.value === value ? `checked` : `unchecked`}
        data-state={state.value === value ? `checked` : `unchecked`}
        aria-checked={state.value === value}
        onClick={handleValueChange}
      >
        {mappedChildren}
      </StyledRadioButton>
    </>
  )
})

Item.displayName = `RadioGroupItem`

export { Item }
